import { Controller } from "@hotwired/stimulus"

// Keep the cost card anchored while Turbo replaces only the income-check frame.
export default class extends Controller {
  render(event) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    const render = event.detail.render
    event.detail.render = (current, incoming) => {
      const height = current.getBoundingClientRect().height
      render(current, incoming)
      const nextHeight = current.getBoundingClientRect().height
      current.animate([{ height: `${height}px`, overflow: "hidden" }, { height: `${nextHeight}px`, overflow: "hidden" }],
        { duration: 380, easing: "cubic-bezier(.22,1,.36,1)" })
    }
  }
}
